<template>
  <div class="QuantityInput flex w-full lg:w-auto lg:inline-flex border-b border-primary-200 pb-3 text-sm">
    <label for="quantity" class="text-primary-500"> {{ $t('qty') }} .</label>

    <button class="ml-5" type="button" data-attr="cartItem__increase" @click="decrease">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 15 2"
        width="15"
        height="2"
        class="stroke-current text-primary-1-100"
      >
        <path d="M0 .557h15" fill="none" fill-rule="evenodd" />
      </svg>
    </button>
    <input
      class="text-primary-1-100 font-bold ml-auto lg:ml-0"
      :value="value"
      type="number"
      step="1"
      min="1"
      data-attr="cartItem__value"
      :max="max"
      @change="onChange"
    />
    <button class="ml-auto lg:ml-5" type="button" data-attr="cartItem__decrease" @click="increase">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 15 15"
        width="15"
        height="15"
        class="stroke-current text-primary-1-100"
      >
        <g stroke="#1D2D50" fill="none" fill-rule="evenodd"><path d="M0 7.5h15M7.5.357v14.286" /></g>
      </svg>
    </button>
  </div>
</template>

<script setup lang="ts">
defineComponent({
  name: 'QuantityInput',
});
const props = defineProps({
  max: {
    type: Number,
    default: 100,
  },
  value: {
    type: Number,
    default: 1,
  },
});

const emit = defineEmits(['input']);

function onChange(e: Event) {
  emit('input', (e.target as HTMLInputElement).value);
}

function increase() {
  if (props.value >= props.max) {
    return;
  }

  emit('input', props.value + 1);
}

function decrease() {
  if (props.value <= 1) {
    return;
  }
  emit('input', props.value - 1);
}
</script>

<style lang="postcss" scoped>
input {
  @apply text-primary-1-100;
  min-width: 68px;
  appearance: textfield;
  text-align: center;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
}

button {
  @apply focus:outline-none;
}
</style>

<i18n>
{
  "en": {
    "qty": "Qty"
  },
  "ar": {
    "qty": "كمية"
  }
}
</i18n>
